import { useIntl } from "react-intl";

import Badge, { type BadgeColor } from "components/v2/Badge/Badge";
import { ReactComponent as InfoCircleIcon } from "assets/images/iconsV2/info-circle.svg";

import "./ParcelWarningBadge.scss";

interface ParcelWarningBadgeProps {
  color?: BadgeColor;
}

const HANDLING_UNIT_MESSAGE = {
  id: "request-form.packing-list.parcelHandlingUnitWarning",
  defaultMessage: "Please add at least one handling unit for Parcel",
};

export default function ParcelWarningBadge({ color = "warning" }: ParcelWarningBadgeProps) {
  const intl = useIntl();
  const message = HANDLING_UNIT_MESSAGE;

  return (
    <Badge
      type="category-badge"
      color={color}
      size="sm"
      variant="icon-leading"
      icon={<InfoCircleIcon className="rfv2-parcel-warning-badge__icon" />}
      label={intl.formatMessage(message)}
    />
  );
}
